// Image imports
import AmyYaimg from '../../images/Amy_Yai.jpeg';
import Sallyimg from '../../images/tour/Sally_Mower.jpg';
import Stephenimg from '../../images/tour/Stephen_img.jpg';
import { id } from 'date-fns/locale';

// Testimonials data
export const TESTIMONIALS = [
  {
    id: 1,
    name: 'Sally Mower',
    image: Sallyimg,
    quote: 'Seamless, Enriching, Unforgettable.',
    description:
      "I honestly couldn't believe how much we saw in just two weeks—it felt like we packed in a month's worth of experiences! Adam somehow managed to show us more than what was even on the original itinerary, without it ever feeling rushed. We didn't have to worry about any of the planning, accommodations, or driving, so the whole trip was completely stress-free.",
  },
  {
    id: 2,
    name: 'Amy Yai',
    image: AmyYaimg,
    quote: 'Highly recommend!',
    description:
      "Our Lineage tour of Great Britain was truly the trip of a lifetime! It helped me to understand secular and Christian history as one great whole, and to see God's hand in it all.",
  },
  {
    id: 3,
    name: 'Stephen Waterbrook',
    image: Stephenimg,
    quote: 'Humbling and Unforgettable',
    description:
      "Lineage Journey Tours took us into the heart of the Waldensian story. Seeing their simple faith, worshiping even in caves amid the beauty of the Italian Alps, was both humbling and unforgettable.",

  }
];

// Text content constants
export const TEXT_CONTENT = {
  title: 'What Past Travelers Are Saying',
  subtitle: 'Real stories from those who walked the journey before you.',
  placeholderImage: '/placeholder.svg',
};

// Carousel navigation SVG icons
export const CAROUSEL_ICONS = {
  prev: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>',
  next: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>',
};

// Owl Carousel configuration options
export const CAROUSEL_OPTIONS = {
  loop: true,
  margin: 30,
  nav: true,
  dots: true,
  autoplay: false,
  dotsContainer: '.nav-dots',
  navContainer: '.nav-arrows',
  responsive: {
    0: {
      items: 1,
      nav: true,
    },
    768: {
      items: 2,
      nav: true,
    },
    1024: {
      items: 3,
      nav: true,
    },
  },
  navText: [CAROUSEL_ICONS.prev, CAROUSEL_ICONS.next],
};
